<div
  [ngClass]="{
    'border-0':
      contentFooter &&
      ((!contentFooter.countryLanguage && !contentFooter.social) ||
        !contentFooter.countryLanguage),
    'no-border-right':
      contentFooter &&
      contentFooter.countryLanguage &&
      contentFooter.social &&
      contentFooter.feedback,
    'mr-md-0':
      contentFooter &&
      ((!contentFooter.countryLanguage && !contentFooter.social) ||
        (!contentFooter.countryLanguage && contentFooter.social) ||
        (contentFooter.countryLanguage && !contentFooter.social)),
    'pad-rt-30':
      contentFooter && contentFooter.countryLanguage && !contentFooter.social
  }"
  class="website-feeddback-container border-right"
>
  <a
    [attr.href]="contentFeedback ? contentFeedback.fbUrl : '#'"
    [ngClass]="{
      'p-0':
        contentFooter &&
        ((contentFooter.countryLanguage && !contentFooter.social) ||
          (!contentFooter.countryLanguage && contentFooter.social))
    }"
    class="footer-feedback"
    target="_blank"
  >
    <img [src]="contentFeedback?.fbIconPath" alt="feedback" />
    <span role="link">
      {{ contentFeedback ? contentFeedback.fbTitle : 'Website Feedback' }}
    </span>
    <span class="sr-only">Opens in a new window.</span>
  </a>
</div>
